import { useEffect, useRef } from "react";

/** When a pop-up closes (Cancel, X, Escape, a click outside, or after saving), put its form back as it started, so it opens fresh next time.
 *  Resets on close rather than on open, so an edit form filled in just before it opens keeps its values. */
export function useResetOnClose(open, reset) {
  const was = useRef(open);
  const fn = useRef(reset);
  fn.current = reset;
  useEffect(() => {
    if (was.current && !open) fn.current();
    was.current = open;
  }, [open]);
}
